var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flash-card-deck"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col offset-2 col-8"},[_c('DeckHeader',{attrs:{"deck":_vm.deck}}),_vm._v(" "),_c('Study',{attrs:{"mode":"review","deck":_vm.deck}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }